
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from '@/components/ui/dialog';

const BrokerageFinalCTA = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <section className="py-16 bg-gradient-to-br from-nexx-green to-green-700 text-white section-float">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold mb-4">
          Need a Circuit That Works for You—Not Just for the Broker?
        </h2>
        <p className="text-xl mb-8 opacity-90">
          Let's build your deal the right way, from the ground up.
        </p>
        
        <div className="flex justify-center">
          <Button 
            size="lg" 
            className="bg-white text-nexx-green hover:bg-gray-100 px-8 py-4 text-lg font-semibold"
            onClick={() => setIsDialogOpen(true)}
          >
            Get Started with Brokerage
          </Button>
        </div>

        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] p-0 overflow-hidden">
            <DialogTitle className="sr-only">Get Started with Brokerage</DialogTitle>
            <DialogDescription className="sr-only">
              Fill out this form to get started with our brokerage services
            </DialogDescription>
            <div className="w-full h-[85vh] p-4">
              <h3 className="text-2xl font-bold text-center mb-4 text-gray-900">
                Let's Connect You With Our Business Team
              </h3>
              <iframe 
                src="https://tally.so/embed/3NQKvW?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                loading="lazy" 
                width="100%" 
                height="100%"
                style={{ border: 'none', borderRadius: '8px' }}
                title="Brokerage Service Request"
                className="w-full h-full rounded-lg"
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default BrokerageFinalCTA;
